import { Icon, IconProps } from '@chakra-ui/react';

export default function BracketIcon({ ...props }: IconProps) {
  return (
    <Icon viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M62.2549 77.9476H74.646C75.7642 77.9476 76.8365 77.5034 77.6272 76.7127C78.4178 75.9221 78.862 74.8497 78.862 73.7316V62.5493L87.1731 53.4827L78.862 45.0507V34.216C78.862 33.0978 78.4178 32.0255 77.6272 31.2348C76.8365 30.4442 75.7642 30 74.646 30H62.2549"
        stroke="#5ECD4C"
        strokeWidth="3.02222"
        strokeLinejoin="round"
      />
      <path
        d="M45.9182 77.9476H33.5271C32.9729 77.9496 32.4238 77.8419 31.9114 77.6307C31.3989 77.4196 30.9334 77.1091 30.5415 76.7172C30.1496 76.3253 29.8391 75.8597 29.6279 75.3473C29.4168 74.8349 29.3091 74.2858 29.3111 73.7316V62.5494L21 53.4827L29.3111 45.0507V34.216C29.3091 33.6618 29.4168 33.1127 29.6279 32.6003C29.8391 32.0879 30.1496 31.6223 30.5415 31.2304C30.9334 30.8385 31.3989 30.5281 31.9114 30.3169C32.4238 30.1057 32.9729 29.998 33.5271 30H45.9182"
        stroke="#5ECD4C"
        strokeWidth="3.02222"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
